var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnmuteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4935 14.1605C12.7881 13.8073 13.3143 13.7597 13.6678 14.0539L14.9235 15.1013C15.2767 15.3959 15.3245 15.9214 15.0301 16.2749C14.7355 16.6281 14.2101 16.6758 13.8566 16.3814L12.6001 15.3349C12.2469 15.0402 12.199 14.514 12.4935 14.1605ZM8.59942 4.59757C8.84225 4.37217 9.19583 4.31148 9.4995 4.44376C9.80325 4.57623 9.99992 4.87652 10 5.20792V14.7913C10 15.1227 9.80333 15.4229 9.4995 15.5554C9.19575 15.6877 8.84225 15.627 8.59942 15.4016L5.92285 12.9163H4.16667C3.24619 12.9163 2.5 12.17 2.5 11.2496V8.7496C2.50007 7.82916 3.24623 7.08292 4.16667 7.08292H5.92285L8.59942 4.59757ZM15.8333 9.16627C16.2934 9.16643 16.6666 9.53952 16.6667 9.9996C16.6666 10.4597 16.2934 10.8328 15.8333 10.8329H14.1667C13.7066 10.8328 13.3334 10.4597 13.3333 9.9996C13.3334 9.53952 13.7066 9.16643 14.1667 9.16627H15.8333ZM13.8566 3.61774C14.2101 3.32347 14.7355 3.37115 15.0301 3.72435C15.3245 4.07787 15.2768 4.60407 14.9235 4.89867L13.6678 5.94522C13.3143 6.23956 12.7881 6.1919 12.4935 5.83861C12.1991 5.48527 12.2472 4.95983 12.6001 4.66511L13.8566 3.61774Z",
    fill: "var(--secondaryText)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteIcon);
export default __webpack_public_path__ + "static/media/unmute-icon.30b587cf6b7ad553bc189842efd30f3b.svg";
export { ForwardRef as ReactComponent };